import { Fragment, h } from "preact";
import { RoutableProps, useRouter } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { translate } from "services/translations";
import { Spinner } from "uitoolkit";
import { validateOnetimeToken } from "services/backend";
import { usePageTitle } from "hooks";

enum State {
    Pending,
    Done,
    Error
}

export const VerifyEmailbox = (props: RoutableProps) => {
    usePageTitle(translate("verifyemail_pagetitle"));

    const [state, setState] = useState<State>(State.Pending);
    //const [email, setEmail] = useState("");

    const [ctx] = useRouter();
    useEffect(() => {
        // const token = base64Decode(ctx.matches?.token ?? "");
        const token = ctx.matches?.token;
        if (!token) {
            setState(State.Error);
            return;
        }
        //console.log("TOKEN: " + token);
        validateOnetimeToken(token)
            .then(res => {
                if (res?.data?.user.validateOnetimeToken.ok && res.data.user.validateOnetimeToken.action == "verify_email") {
                    //setEmail(res!.data.user.validateOnetimeToken.email ?? "");
                    setState(State.Done);
                }
                else {
                    setState(State.Error);
                }
            })
    }, [ctx.matches?.token])

    return (
        <Fragment>
            {
                // Show a spinner while we verify the email
                state === State.Pending && <Fragment>
                    <div class="flex-column center">
                        <Spinner class="small" />
                    </div>
                </Fragment>
            }
            {
                // Show an error if the token was invalid or there was a problem
                state === State.Error && <Fragment>
                    <header>
                        <h1>{translate("verifyemail_headline_error")}</h1>
                        <h2>{translate("verifyemail_description_error")}</h2>
                    </header>
                </Fragment>
            }
            {
                // Confirm that the email was verified
                state === State.Done && <Fragment>
                    <header>
                        <h1>{translate("verifyemail_headline_ok")}</h1>
                        <h2>{translate("verifyemail_description_ok")}</h2>
                    </header>
                </Fragment>
            }
        </Fragment>
    );

};
